import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// eslint-disable-next-line no-unused-vars
import NextRouter from 'next/router';
import { getResolveRoute } from './dynamicRoutesModule';
import logger from './logger';
var debug = logger.extend('Router');
/**
 * @type {NextRouter}
 */

var Router = _objectSpread(_objectSpread({}, NextRouter), {}, {
  push: function push(href, asPath, options) {
    if (options == null && typeof asPath !== 'string') {
      options = asPath;
      asPath = undefined;
    }

    var route = Router.resolve(href, asPath); //  avoid scroll for urls with anchor refs

    var _ref = options || {},
        scroll = _ref.scroll;

    if (scroll == null) {
      var _asPath = route.asPath || route.href;

      if (typeof _asPath === 'string') {
        scroll = _asPath.indexOf('#') < 0;
      } else {
        scroll = Boolean(route.href.hash);
      }
    }

    return NextRouter.push(route.href, route.asPath, options).then(function (success) {
      if (scroll && success) {
        window.scrollTo(0, 0);
        document.body.focus();
      }

      return success;
    });
  },
  replace: function replace(href, asPath, options) {
    if (options == null && typeof asPath !== 'string') {
      options = asPath;
      asPath = undefined;
    }

    var route = Router.resolve(href, asPath);
    return NextRouter.replace(route.href, route.asPath, options);
  },
  resolve: function resolve(href, asPath) {
    if (process.browser && window.__NEXT_REDUX_STORE__) {
      var resolveRoute = window.__NEXT_REDUX_STORE__.dispatch(getResolveRoute());

      var route = resolveRoute(href, asPath);
      debug('Resolved %o to: %o', href, route.href);
      return route;
    }

    return {
      href: href,
      asPath: asPath
    };
  }
});

export default Router;